import { render } from "./SingleCasesStudy.vue?vue&type=template&id=189854ef"
import script from "./SingleCasesStudy.vue?vue&type=script&lang=js"
export * from "./SingleCasesStudy.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zhouyi/workplace/node/djweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__